module.exports = __webpack_public_path__ + "static/media/bz.510d2519.svg";